import React from 'react';

import TabLabel from '../../ClassRoom/Settings/TabLabel';

export default [
  {
    id: 'community',
    label: <TabLabel text="Community" icon={null} />,
    documentTitlePrefix: 'Community',
    visible: () => true,
  },
  {
    id: 'journey',
    label: <TabLabel text="Journey" icon={null} />,
    documentTitlePrefix: 'Journey',
    visible: () => true,
  },
];
